import { AutogenModelCarrierDriver, AutogenRowCarrierDriver } from "./autogen/AutogenModelCarrierDriver";

export class ModelCarrierDriver extends AutogenModelCarrierDriver<RowCarrierDriver> {
    constructor() {
        super(RowCarrierDriver);
    }
}

export class RowCarrierDriver extends AutogenRowCarrierDriver {
}